import * as imagesLoaded from 'imagesloaded'
import gsap from 'gsap'
import { ScrollTrigger , ScrollToPlugin } from 'gsap/all'
import GsapSmoothScroll from './class/GsapSmoothScroll'
import common from './common'
import index from './index'
import partials from './partials'

gsap.registerPlugin(ScrollToPlugin)

let smoother
document.addEventListener('DOMContentLoaded', function() {
  imagesLoaded(document.getElementById('app'), () => {

    partials().then(() => {
      common()
      index()
      setProp()
      setTimeout(()=>{
        smoothScrollToTargetIfHashExists()
      },800)
    })
  })
})

function setProp() {
  if (smoother != null) {
    document.documentElement.style.setProperty('--screen', `${smoother.getOffsets()}px`)
  } else {
    cancelAnimationFrame(setProp)
  }
  requestAnimationFrame(setProp)
}

function smoothScrollToTargetIfHashExists() {
  const hash = window.location.hash;
  
  if (hash && hash !== "#") {
    const targetElement = document.getElementById(hash.split("#")[1]);
    if (targetElement) {
      scrollToAnimated(targetElement)
    }
  }
}

function scrollToAnimated(targetElement) {
  //const headerHeight = document.getElementById('site-header').offsetHeight;
  const headerHeight = 0
  const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
  gsap.to(window, { duration: 0.8, scrollTo: targetPosition });
}

